/* Article — Premium. ~2.5KB, deferred, no dependencies.
   Builds the TOC from H2/H3 in the article body (including
   Bloggle-generated headings), runs scroll-spy, the reading
   progress bar, and the copy-link button. Everything degrades
   gracefully if elements are absent. */
(function () {
  'use strict';

  var body = document.querySelector('[data-ech-body]');
  if (!body) return;

  /* ---------- Table of contents ---------- */
  var toc = document.querySelector('[data-ech-toc]');
  var tocList = document.querySelector('[data-ech-toc-list]');
  var headings = [];

  if (toc && tocList) {
    headings = Array.prototype.slice.call(body.querySelectorAll('h2, h3'));

    // Skip headings inside Bloggle FAQ accordions or product blocks if
    // marked with data-ech-toc-ignore by the merchant.
    headings = headings.filter(function (h) {
      return h.textContent.trim().length > 0 && !h.closest('[data-ech-toc-ignore]');
    });

    if (headings.length >= 2) {
      var slugCounts = {};
      headings.forEach(function (h) {
        if (!h.id) {
          var slug = h.textContent.trim().toLowerCase()
            .replace(/[^\w\s-]/g, '')
            .replace(/\s+/g, '-')
            .slice(0, 60) || 'section';
          if (slugCounts[slug] != null) {
            slugCounts[slug]++;
            slug += '-' + slugCounts[slug];
          } else {
            slugCounts[slug] = 0;
          }
          h.id = slug;
        }
        var li = document.createElement('li');
        li.dataset.level = h.tagName === 'H3' ? '3' : '2';
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent.trim();
        li.appendChild(a);
        tocList.appendChild(li);
      });
      toc.hidden = false;

      /* Scroll-spy */
      if ('IntersectionObserver' in window) {
        var links = tocList.querySelectorAll('a');
        var activeId = null;
        var spy = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) activeId = entry.target.id;
          });
          links.forEach(function (a) {
            a.classList.toggle('is-active', a.getAttribute('href') === '#' + activeId);
          });
        }, { rootMargin: '-100px 0px -66% 0px' });
        headings.forEach(function (h) { spy.observe(h); });
      }
    }
  }

  /* ---------- Reading progress ---------- */
  var bar = document.querySelector('[data-ech-progress]');
  if (bar) {
    var ticking = false;
    var update = function () {
      var rect = body.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var progress = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 0;
      bar.style.width = (progress * 100).toFixed(2) + '%';
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ---------- Copy link ---------- */
  var copyBtn = document.querySelector('[data-ech-copy]');
  if (copyBtn && navigator.clipboard) {
    copyBtn.addEventListener('click', function () {
      navigator.clipboard.writeText(copyBtn.dataset.url || window.location.href).then(function () {
        copyBtn.classList.add('is-copied');
        setTimeout(function () { copyBtn.classList.remove('is-copied'); }, 1600);
      });
    });
  }

  /* ---------- Lazy-load safety net for Bloggle images ---------- */
  body.querySelectorAll('img:not([loading])').forEach(function (img) {
    img.loading = 'lazy';
    img.decoding = 'async';
  });
})();
